//NOTE: this currently will not support the american express card format because we arent accepting that yet
//if we decide to accept it i will add support for thier number format too
const normalizeCreditCardNumber = value => {
  if(!value) {
    return value;
  }

  let normalized = value.replace(/[^\d]/g, "");
  if(normalized.length > 16)normalized = normalized.slice(0, 16);

  for(let i = Math.floor((normalized.length-1)/4) * 4; i > 0; i -= 4) {
    normalized = normalized.slice(0, i) + " " + normalized.slice(i);
  }

  return normalized;
};

const normalizeCreditCardCVC = value => {
  if (!value) {
    return value;
  }

  let onlyNums = value.replace(/[^\d]/g, "");
  if (onlyNums.length > 4) {
    onlyNums = onlyNums.slice(0,4);
  }

  return onlyNums;
};
  
export { normalizeCreditCardNumber, normalizeCreditCardCVC };